module.exports = __webpack_public_path__ + "img/hotel_NEST.88ffef49.jpg";